import { useState } from 'react';

import { VFlex } from '@/components/base';
import { Stage } from '@/components/Stage/Stage';
import { CHART_TYPE } from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';

import ChartTypeSelect from './components/ChartTypeSelect';
import { CrossAxisController } from './controllers/cross-axis-controller';
import { SingleAxisController } from './controllers/single-axis-controller';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartController = (props: Props) => {
  const { chartInfo } = props;
  const { state } = chartInfo;
  const [switchCount, setSwitchCount] = useState(0);
  const { onChartTypeChange } = useChartStateAction(props.chartInfo);

  return (
    <VFlex g={16} className="w-full p-6">
      <ChartTypeSelect value={state.type} onChange={onChartTypeChange} />
      <Stage>
        <Stage.Scene
          status={state.type === CHART_TYPE.SINGLE_AXIS}
          className="flex flex-col gap-5"
        >
          <SingleAxisController
            chartInfo={chartInfo}
            switchCount={switchCount}
          />
        </Stage.Scene>

        <Stage.Scene
          status={state.type === CHART_TYPE.CROSS_AXIS}
          className="flex flex-col gap-5"
        >
          <CrossAxisController
            chartInfo={chartInfo}
            switchCount={switchCount}
            setSwitchCount={setSwitchCount}
          />
        </Stage.Scene>
      </Stage>
    </VFlex>
  );
};

export default ChartController;
